export class MyErrorHandler extends Error {
    public type?: string;
    constructor(type?: string) {
        super('Error');
        this.name = 'MyErrorHandler';
        this.type = type;
    }
}
